/**
 * Smartfactor API
 * API for Smartfactor System
 *
 * The version of the OpenAPI document: 0.4.297
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { TaxObjectAppEntityTaxObjectItemRead } from '../model/taxObjectAppEntityTaxObjectItemRead';
// @ts-ignore
import { TaxObjectAppEntityTaxObjectRead } from '../model/taxObjectAppEntityTaxObjectRead';
// @ts-ignore
import { TaxObjectAppEntityTaxObjectWrite } from '../model/taxObjectAppEntityTaxObjectWrite';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


export interface DeleteTaxObjectTaxObjectItemRequestParams {
    id: string;
}

export interface GetTaxObjectCollectionTaxObjectCollectionRequestParams {
    id?: string;
    id2?: Array<string>;
    city?: string;
    city2?: Array<string>;
    street?: string;
    street2?: Array<string>;
    houseNumber?: string;
    houseNumber2?: Array<string>;
    additionalLocationDescription?: string;
    additionalLocationDescription2?: Array<string>;
    landRegisterNumber?: string;
    landRegisterNumber2?: Array<string>;
    documentCollectionNumber?: string;
    documentCollectionNumber2?: Array<string>;
    notarialDeedNumber?: string;
    notarialDeedNumber2?: Array<string>;
    notarialDeedDate?: string;
    notarialDeedDate2?: string;
    contractNumber?: string;
    contractNumber2?: Array<string>;
    contractDate?: string;
    contractDate2?: string;
    possessionForm?: string;
    possessionForm2?: Array<string>;
    isPartOfNatureReserve?: boolean;
    isPartOfNatureReserve2?: Array<boolean>;
    taxExemption?: boolean;
    taxExemption2?: Array<boolean>;
    taxExemptionBasis?: string;
    taxExemptionBasis2?: Array<string>;
    districtNumber?: string;
    districtNumber2?: Array<string>;
    parcelNumber?: string;
    parcelNumber2?: Array<string>;
    areaHa?: number;
    areaHa2?: Array<number>;
    hasLandRegister?: boolean;
    hasLandRegister2?: Array<boolean>;
    additionalIdentification?: string;
    additionalIdentification2?: Array<string>;
    isTaxExempt?: boolean;
    isTaxExempt2?: Array<boolean>;
    propertyType?: string;
    propertyType2?: Array<string>;
    landType?: string;
    landType2?: Array<string>;
    landClass?: string;
    landClass2?: Array<string>;
    hasAgriculturalFarm?: boolean;
    hasAgriculturalFarm2?: Array<boolean>;
    areaAbove22m?: number;
    areaAbove22m2?: Array<number>;
    areaBetween14and22m?: number;
    areaBetween14and22m2?: Array<number>;
    groundType?: string;
    groundType2?: Array<string>;
    buildingType?: string;
    buildingType2?: Array<string>;
    garageType?: string;
    garageType2?: Array<string>;
    structureName?: string;
    structureName2?: Array<string>;
    inventoryNumber?: string;
    inventoryNumber2?: Array<string>;
    structureValue?: string;
    structureValue2?: Array<string>;
    areaM2?: number;
    areaM3?: Array<number>;
    areaType?: string;
    areaType2?: Array<string>;
    usageClass?: string;
    usageClass2?: Array<string>;
    isTaxExemptType?: boolean;
    isTaxExemptType2?: Array<boolean>;
    taxExemptType?: string;
    taxExemptType2?: Array<string>;
    reliefType?: string;
    reliefType2?: Array<string>;
    reliefValuePercent?: number;
    reliefValuePercent2?: Array<number>;
    reliefValueAmount?: number;
    reliefValueAmount2?: Array<number>;
    reliefValueScope?: string;
    reliefValueScope2?: Array<string>;
    reliefLegalBasis?: string;
    reliefLegalBasis2?: Array<string>;
    residenceChangeDate?: string;
    residenceChangeDate2?: string;
    previousTaxAuthorityAddress?: string;
    previousTaxAuthorityAddress2?: Array<string>;
    taxpayerStatus?: string;
    taxpayerStatus2?: Array<string>;
    vehicleType?: string;
    vehicleType2?: Array<string>;
    registrationNumber?: string;
    registrationNumber2?: Array<string>;
    vin?: string;
    vin2?: Array<string>;
    brand?: string;
    brand2?: Array<string>;
    model?: string;
    model2?: Array<string>;
    vehicleTotalWeight?: number;
    vehicleTotalWeight2?: Array<number>;
    vehicleSetTotalWeight?: number;
    vehicleSetTotalWeight2?: Array<number>;
    tractorWeight?: number;
    tractorWeight2?: Array<number>;
    environmentalImpact?: string;
    environmentalImpact2?: Array<string>;
    axlesCount?: number;
    axlesCount2?: Array<number>;
    seatsCount?: number;
    seatsCount2?: Array<number>;
    productionYear?: number;
    productionYear2?: Array<number>;
    acquisitionDate?: string;
    acquisitionDate2?: string;
    firstRegistrationDate?: string;
    firstRegistrationDate2?: string;
    taxEvent?: string;
    taxEvent2?: Array<string>;
    vehicleSaleDate?: string;
    vehicleSaleDate2?: string;
    vehicleDeregistrationDate?: string;
    vehicleDeregistrationDate2?: string;
    createdAt?: string;
    createdAt2?: string;
    updatedAt?: string;
    updatedAt2?: string;
    deletedAt?: string;
    deletedAt2?: string;
    /** The collection page number */
    page?: number;
    /** The number of items per page */
    itemsPerPage?: number;
    /** Enable or disable pagination */
    pagination?: boolean;
}

export interface GetTaxObjectItemTaxObjectItemRequestParams {
    id: string;
}

export interface PatchTaxObjectTaxObjectItemRequestParams {
    id: string;
    /** The updated TaxObject resource */
    taxObject?: TaxObjectAppEntityTaxObjectWrite;
}

export interface PostTaxObjectTaxObjectCollectionRequestParams {
    /** The new TaxObject resource */
    taxObject?: TaxObjectAppEntityTaxObjectWrite;
}


@Injectable({
  providedIn: 'root'
})
export class TaxObjectService {

    protected basePath = '/system';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string|string[], @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            const firstBasePath = Array.isArray(basePath) ? basePath[0] : undefined;
            if (firstBasePath != undefined) {
                basePath = firstBasePath;
            }

            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }


    // @ts-ignore
    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key, (value as Date).toISOString().substring(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * Removes the TaxObject resource.
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteTaxObjectTaxObjectItem(requestParameters?: DeleteTaxObjectTaxObjectItemRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<any>;
    public deleteTaxObjectTaxObjectItem(requestParameters?: DeleteTaxObjectTaxObjectItemRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<HttpResponse<any>>;
    public deleteTaxObjectTaxObjectItem(requestParameters?: DeleteTaxObjectTaxObjectItemRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<HttpEvent<any>>;
    public deleteTaxObjectTaxObjectItem(requestParameters?: DeleteTaxObjectTaxObjectItemRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<any> {
        const id = requestParameters?.id;
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling deleteTaxObjectTaxObjectItem.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (apiKey) required
        localVarCredential = this.configuration.lookupCredential('apiKey');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/tax_objects/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        return this.httpClient.request<any>('delete', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Retrieves the collection of TaxObject resources.
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getTaxObjectCollectionTaxObjectCollection(requestParameters?: GetTaxObjectCollectionTaxObjectCollectionRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<Array<TaxObjectAppEntityTaxObjectRead>>;
    public getTaxObjectCollectionTaxObjectCollection(requestParameters?: GetTaxObjectCollectionTaxObjectCollectionRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<HttpResponse<Array<TaxObjectAppEntityTaxObjectRead>>>;
    public getTaxObjectCollectionTaxObjectCollection(requestParameters?: GetTaxObjectCollectionTaxObjectCollectionRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<HttpEvent<Array<TaxObjectAppEntityTaxObjectRead>>>;
    public getTaxObjectCollectionTaxObjectCollection(requestParameters?: GetTaxObjectCollectionTaxObjectCollectionRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<any> {
        const id = requestParameters?.id;
        const id2 = requestParameters?.id2;
        const city = requestParameters?.city;
        const city2 = requestParameters?.city2;
        const street = requestParameters?.street;
        const street2 = requestParameters?.street2;
        const houseNumber = requestParameters?.houseNumber;
        const houseNumber2 = requestParameters?.houseNumber2;
        const additionalLocationDescription = requestParameters?.additionalLocationDescription;
        const additionalLocationDescription2 = requestParameters?.additionalLocationDescription2;
        const landRegisterNumber = requestParameters?.landRegisterNumber;
        const landRegisterNumber2 = requestParameters?.landRegisterNumber2;
        const documentCollectionNumber = requestParameters?.documentCollectionNumber;
        const documentCollectionNumber2 = requestParameters?.documentCollectionNumber2;
        const notarialDeedNumber = requestParameters?.notarialDeedNumber;
        const notarialDeedNumber2 = requestParameters?.notarialDeedNumber2;
        const notarialDeedDate = requestParameters?.notarialDeedDate;
        const notarialDeedDate2 = requestParameters?.notarialDeedDate2;
        const contractNumber = requestParameters?.contractNumber;
        const contractNumber2 = requestParameters?.contractNumber2;
        const contractDate = requestParameters?.contractDate;
        const contractDate2 = requestParameters?.contractDate2;
        const possessionForm = requestParameters?.possessionForm;
        const possessionForm2 = requestParameters?.possessionForm2;
        const isPartOfNatureReserve = requestParameters?.isPartOfNatureReserve;
        const isPartOfNatureReserve2 = requestParameters?.isPartOfNatureReserve2;
        const taxExemption = requestParameters?.taxExemption;
        const taxExemption2 = requestParameters?.taxExemption2;
        const taxExemptionBasis = requestParameters?.taxExemptionBasis;
        const taxExemptionBasis2 = requestParameters?.taxExemptionBasis2;
        const districtNumber = requestParameters?.districtNumber;
        const districtNumber2 = requestParameters?.districtNumber2;
        const parcelNumber = requestParameters?.parcelNumber;
        const parcelNumber2 = requestParameters?.parcelNumber2;
        const areaHa = requestParameters?.areaHa;
        const areaHa2 = requestParameters?.areaHa2;
        const hasLandRegister = requestParameters?.hasLandRegister;
        const hasLandRegister2 = requestParameters?.hasLandRegister2;
        const additionalIdentification = requestParameters?.additionalIdentification;
        const additionalIdentification2 = requestParameters?.additionalIdentification2;
        const isTaxExempt = requestParameters?.isTaxExempt;
        const isTaxExempt2 = requestParameters?.isTaxExempt2;
        const propertyType = requestParameters?.propertyType;
        const propertyType2 = requestParameters?.propertyType2;
        const landType = requestParameters?.landType;
        const landType2 = requestParameters?.landType2;
        const landClass = requestParameters?.landClass;
        const landClass2 = requestParameters?.landClass2;
        const hasAgriculturalFarm = requestParameters?.hasAgriculturalFarm;
        const hasAgriculturalFarm2 = requestParameters?.hasAgriculturalFarm2;
        const areaAbove22m = requestParameters?.areaAbove22m;
        const areaAbove22m2 = requestParameters?.areaAbove22m2;
        const areaBetween14and22m = requestParameters?.areaBetween14and22m;
        const areaBetween14and22m2 = requestParameters?.areaBetween14and22m2;
        const groundType = requestParameters?.groundType;
        const groundType2 = requestParameters?.groundType2;
        const buildingType = requestParameters?.buildingType;
        const buildingType2 = requestParameters?.buildingType2;
        const garageType = requestParameters?.garageType;
        const garageType2 = requestParameters?.garageType2;
        const structureName = requestParameters?.structureName;
        const structureName2 = requestParameters?.structureName2;
        const inventoryNumber = requestParameters?.inventoryNumber;
        const inventoryNumber2 = requestParameters?.inventoryNumber2;
        const structureValue = requestParameters?.structureValue;
        const structureValue2 = requestParameters?.structureValue2;
        const areaM2 = requestParameters?.areaM2;
        const areaM3 = requestParameters?.areaM3;
        const areaType = requestParameters?.areaType;
        const areaType2 = requestParameters?.areaType2;
        const usageClass = requestParameters?.usageClass;
        const usageClass2 = requestParameters?.usageClass2;
        const isTaxExemptType = requestParameters?.isTaxExemptType;
        const isTaxExemptType2 = requestParameters?.isTaxExemptType2;
        const taxExemptType = requestParameters?.taxExemptType;
        const taxExemptType2 = requestParameters?.taxExemptType2;
        const reliefType = requestParameters?.reliefType;
        const reliefType2 = requestParameters?.reliefType2;
        const reliefValuePercent = requestParameters?.reliefValuePercent;
        const reliefValuePercent2 = requestParameters?.reliefValuePercent2;
        const reliefValueAmount = requestParameters?.reliefValueAmount;
        const reliefValueAmount2 = requestParameters?.reliefValueAmount2;
        const reliefValueScope = requestParameters?.reliefValueScope;
        const reliefValueScope2 = requestParameters?.reliefValueScope2;
        const reliefLegalBasis = requestParameters?.reliefLegalBasis;
        const reliefLegalBasis2 = requestParameters?.reliefLegalBasis2;
        const residenceChangeDate = requestParameters?.residenceChangeDate;
        const residenceChangeDate2 = requestParameters?.residenceChangeDate2;
        const previousTaxAuthorityAddress = requestParameters?.previousTaxAuthorityAddress;
        const previousTaxAuthorityAddress2 = requestParameters?.previousTaxAuthorityAddress2;
        const taxpayerStatus = requestParameters?.taxpayerStatus;
        const taxpayerStatus2 = requestParameters?.taxpayerStatus2;
        const vehicleType = requestParameters?.vehicleType;
        const vehicleType2 = requestParameters?.vehicleType2;
        const registrationNumber = requestParameters?.registrationNumber;
        const registrationNumber2 = requestParameters?.registrationNumber2;
        const vin = requestParameters?.vin;
        const vin2 = requestParameters?.vin2;
        const brand = requestParameters?.brand;
        const brand2 = requestParameters?.brand2;
        const model = requestParameters?.model;
        const model2 = requestParameters?.model2;
        const vehicleTotalWeight = requestParameters?.vehicleTotalWeight;
        const vehicleTotalWeight2 = requestParameters?.vehicleTotalWeight2;
        const vehicleSetTotalWeight = requestParameters?.vehicleSetTotalWeight;
        const vehicleSetTotalWeight2 = requestParameters?.vehicleSetTotalWeight2;
        const tractorWeight = requestParameters?.tractorWeight;
        const tractorWeight2 = requestParameters?.tractorWeight2;
        const environmentalImpact = requestParameters?.environmentalImpact;
        const environmentalImpact2 = requestParameters?.environmentalImpact2;
        const axlesCount = requestParameters?.axlesCount;
        const axlesCount2 = requestParameters?.axlesCount2;
        const seatsCount = requestParameters?.seatsCount;
        const seatsCount2 = requestParameters?.seatsCount2;
        const productionYear = requestParameters?.productionYear;
        const productionYear2 = requestParameters?.productionYear2;
        const acquisitionDate = requestParameters?.acquisitionDate;
        const acquisitionDate2 = requestParameters?.acquisitionDate2;
        const firstRegistrationDate = requestParameters?.firstRegistrationDate;
        const firstRegistrationDate2 = requestParameters?.firstRegistrationDate2;
        const taxEvent = requestParameters?.taxEvent;
        const taxEvent2 = requestParameters?.taxEvent2;
        const vehicleSaleDate = requestParameters?.vehicleSaleDate;
        const vehicleSaleDate2 = requestParameters?.vehicleSaleDate2;
        const vehicleDeregistrationDate = requestParameters?.vehicleDeregistrationDate;
        const vehicleDeregistrationDate2 = requestParameters?.vehicleDeregistrationDate2;
        const createdAt = requestParameters?.createdAt;
        const createdAt2 = requestParameters?.createdAt2;
        const updatedAt = requestParameters?.updatedAt;
        const updatedAt2 = requestParameters?.updatedAt2;
        const deletedAt = requestParameters?.deletedAt;
        const deletedAt2 = requestParameters?.deletedAt2;
        const page = requestParameters?.page;
        const itemsPerPage = requestParameters?.itemsPerPage;
        const pagination = requestParameters?.pagination;

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (id !== undefined && id !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>id, 'id');
        }
        if (id2) {
            id2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'id[]');
            })
        }
        if (city !== undefined && city !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>city, 'city');
        }
        if (city2) {
            city2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'city[]');
            })
        }
        if (street !== undefined && street !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>street, 'street');
        }
        if (street2) {
            street2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'street[]');
            })
        }
        if (houseNumber !== undefined && houseNumber !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>houseNumber, 'houseNumber');
        }
        if (houseNumber2) {
            houseNumber2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'houseNumber[]');
            })
        }
        if (additionalLocationDescription !== undefined && additionalLocationDescription !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>additionalLocationDescription, 'additionalLocationDescription');
        }
        if (additionalLocationDescription2) {
            additionalLocationDescription2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'additionalLocationDescription[]');
            })
        }
        if (landRegisterNumber !== undefined && landRegisterNumber !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>landRegisterNumber, 'landRegisterNumber');
        }
        if (landRegisterNumber2) {
            landRegisterNumber2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'landRegisterNumber[]');
            })
        }
        if (documentCollectionNumber !== undefined && documentCollectionNumber !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>documentCollectionNumber, 'documentCollectionNumber');
        }
        if (documentCollectionNumber2) {
            documentCollectionNumber2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'documentCollectionNumber[]');
            })
        }
        if (notarialDeedNumber !== undefined && notarialDeedNumber !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>notarialDeedNumber, 'notarialDeedNumber');
        }
        if (notarialDeedNumber2) {
            notarialDeedNumber2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'notarialDeedNumber[]');
            })
        }
        if (notarialDeedDate !== undefined && notarialDeedDate !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>notarialDeedDate, 'notarialDeedDate');
        }
        if (notarialDeedDate2 !== undefined && notarialDeedDate2 !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>notarialDeedDate2, 'notarialDeedDate[]');
        }
        if (contractNumber !== undefined && contractNumber !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>contractNumber, 'contractNumber');
        }
        if (contractNumber2) {
            contractNumber2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'contractNumber[]');
            })
        }
        if (contractDate !== undefined && contractDate !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>contractDate, 'contractDate');
        }
        if (contractDate2 !== undefined && contractDate2 !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>contractDate2, 'contractDate[]');
        }
        if (possessionForm !== undefined && possessionForm !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>possessionForm, 'possessionForm');
        }
        if (possessionForm2) {
            possessionForm2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'possessionForm[]');
            })
        }
        if (isPartOfNatureReserve !== undefined && isPartOfNatureReserve !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>isPartOfNatureReserve, 'isPartOfNatureReserve');
        }
        if (isPartOfNatureReserve2) {
            isPartOfNatureReserve2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'isPartOfNatureReserve[]');
            })
        }
        if (taxExemption !== undefined && taxExemption !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>taxExemption, 'taxExemption');
        }
        if (taxExemption2) {
            taxExemption2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'taxExemption[]');
            })
        }
        if (taxExemptionBasis !== undefined && taxExemptionBasis !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>taxExemptionBasis, 'taxExemptionBasis');
        }
        if (taxExemptionBasis2) {
            taxExemptionBasis2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'taxExemptionBasis[]');
            })
        }
        if (districtNumber !== undefined && districtNumber !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>districtNumber, 'districtNumber');
        }
        if (districtNumber2) {
            districtNumber2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'districtNumber[]');
            })
        }
        if (parcelNumber !== undefined && parcelNumber !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>parcelNumber, 'parcelNumber');
        }
        if (parcelNumber2) {
            parcelNumber2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'parcelNumber[]');
            })
        }
        if (areaHa !== undefined && areaHa !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>areaHa, 'areaHa');
        }
        if (areaHa2) {
            areaHa2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'areaHa[]');
            })
        }
        if (hasLandRegister !== undefined && hasLandRegister !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>hasLandRegister, 'hasLandRegister');
        }
        if (hasLandRegister2) {
            hasLandRegister2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'hasLandRegister[]');
            })
        }
        if (additionalIdentification !== undefined && additionalIdentification !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>additionalIdentification, 'additionalIdentification');
        }
        if (additionalIdentification2) {
            additionalIdentification2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'additionalIdentification[]');
            })
        }
        if (isTaxExempt !== undefined && isTaxExempt !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>isTaxExempt, 'isTaxExempt');
        }
        if (isTaxExempt2) {
            isTaxExempt2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'isTaxExempt[]');
            })
        }
        if (propertyType !== undefined && propertyType !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>propertyType, 'propertyType');
        }
        if (propertyType2) {
            propertyType2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'propertyType[]');
            })
        }
        if (landType !== undefined && landType !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>landType, 'landType');
        }
        if (landType2) {
            landType2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'landType[]');
            })
        }
        if (landClass !== undefined && landClass !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>landClass, 'landClass');
        }
        if (landClass2) {
            landClass2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'landClass[]');
            })
        }
        if (hasAgriculturalFarm !== undefined && hasAgriculturalFarm !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>hasAgriculturalFarm, 'hasAgriculturalFarm');
        }
        if (hasAgriculturalFarm2) {
            hasAgriculturalFarm2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'hasAgriculturalFarm[]');
            })
        }
        if (areaAbove22m !== undefined && areaAbove22m !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>areaAbove22m, 'areaAbove22m');
        }
        if (areaAbove22m2) {
            areaAbove22m2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'areaAbove22m[]');
            })
        }
        if (areaBetween14and22m !== undefined && areaBetween14and22m !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>areaBetween14and22m, 'areaBetween14and22m');
        }
        if (areaBetween14and22m2) {
            areaBetween14and22m2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'areaBetween14and22m[]');
            })
        }
        if (groundType !== undefined && groundType !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>groundType, 'groundType');
        }
        if (groundType2) {
            groundType2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'groundType[]');
            })
        }
        if (buildingType !== undefined && buildingType !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>buildingType, 'buildingType');
        }
        if (buildingType2) {
            buildingType2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'buildingType[]');
            })
        }
        if (garageType !== undefined && garageType !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>garageType, 'garageType');
        }
        if (garageType2) {
            garageType2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'garageType[]');
            })
        }
        if (structureName !== undefined && structureName !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>structureName, 'structureName');
        }
        if (structureName2) {
            structureName2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'structureName[]');
            })
        }
        if (inventoryNumber !== undefined && inventoryNumber !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>inventoryNumber, 'inventoryNumber');
        }
        if (inventoryNumber2) {
            inventoryNumber2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'inventoryNumber[]');
            })
        }
        if (structureValue !== undefined && structureValue !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>structureValue, 'structureValue');
        }
        if (structureValue2) {
            structureValue2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'structureValue[]');
            })
        }
        if (areaM2 !== undefined && areaM2 !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>areaM2, 'areaM2');
        }
        if (areaM3) {
            areaM3.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'areaM2[]');
            })
        }
        if (areaType !== undefined && areaType !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>areaType, 'areaType');
        }
        if (areaType2) {
            areaType2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'areaType[]');
            })
        }
        if (usageClass !== undefined && usageClass !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>usageClass, 'usageClass');
        }
        if (usageClass2) {
            usageClass2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'usageClass[]');
            })
        }
        if (isTaxExemptType !== undefined && isTaxExemptType !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>isTaxExemptType, 'isTaxExemptType');
        }
        if (isTaxExemptType2) {
            isTaxExemptType2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'isTaxExemptType[]');
            })
        }
        if (taxExemptType !== undefined && taxExemptType !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>taxExemptType, 'taxExemptType');
        }
        if (taxExemptType2) {
            taxExemptType2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'taxExemptType[]');
            })
        }
        if (reliefType !== undefined && reliefType !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>reliefType, 'reliefType');
        }
        if (reliefType2) {
            reliefType2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'reliefType[]');
            })
        }
        if (reliefValuePercent !== undefined && reliefValuePercent !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>reliefValuePercent, 'reliefValuePercent');
        }
        if (reliefValuePercent2) {
            reliefValuePercent2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'reliefValuePercent[]');
            })
        }
        if (reliefValueAmount !== undefined && reliefValueAmount !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>reliefValueAmount, 'reliefValueAmount');
        }
        if (reliefValueAmount2) {
            reliefValueAmount2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'reliefValueAmount[]');
            })
        }
        if (reliefValueScope !== undefined && reliefValueScope !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>reliefValueScope, 'reliefValueScope');
        }
        if (reliefValueScope2) {
            reliefValueScope2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'reliefValueScope[]');
            })
        }
        if (reliefLegalBasis !== undefined && reliefLegalBasis !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>reliefLegalBasis, 'reliefLegalBasis');
        }
        if (reliefLegalBasis2) {
            reliefLegalBasis2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'reliefLegalBasis[]');
            })
        }
        if (residenceChangeDate !== undefined && residenceChangeDate !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>residenceChangeDate, 'residenceChangeDate');
        }
        if (residenceChangeDate2 !== undefined && residenceChangeDate2 !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>residenceChangeDate2, 'residenceChangeDate[]');
        }
        if (previousTaxAuthorityAddress !== undefined && previousTaxAuthorityAddress !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>previousTaxAuthorityAddress, 'previousTaxAuthorityAddress');
        }
        if (previousTaxAuthorityAddress2) {
            previousTaxAuthorityAddress2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'previousTaxAuthorityAddress[]');
            })
        }
        if (taxpayerStatus !== undefined && taxpayerStatus !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>taxpayerStatus, 'taxpayerStatus');
        }
        if (taxpayerStatus2) {
            taxpayerStatus2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'taxpayerStatus[]');
            })
        }
        if (vehicleType !== undefined && vehicleType !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>vehicleType, 'vehicleType');
        }
        if (vehicleType2) {
            vehicleType2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'vehicleType[]');
            })
        }
        if (registrationNumber !== undefined && registrationNumber !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>registrationNumber, 'registrationNumber');
        }
        if (registrationNumber2) {
            registrationNumber2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'registrationNumber[]');
            })
        }
        if (vin !== undefined && vin !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>vin, 'vin');
        }
        if (vin2) {
            vin2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'vin[]');
            })
        }
        if (brand !== undefined && brand !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>brand, 'brand');
        }
        if (brand2) {
            brand2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'brand[]');
            })
        }
        if (model !== undefined && model !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>model, 'model');
        }
        if (model2) {
            model2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'model[]');
            })
        }
        if (vehicleTotalWeight !== undefined && vehicleTotalWeight !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>vehicleTotalWeight, 'vehicleTotalWeight');
        }
        if (vehicleTotalWeight2) {
            vehicleTotalWeight2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'vehicleTotalWeight[]');
            })
        }
        if (vehicleSetTotalWeight !== undefined && vehicleSetTotalWeight !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>vehicleSetTotalWeight, 'vehicleSetTotalWeight');
        }
        if (vehicleSetTotalWeight2) {
            vehicleSetTotalWeight2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'vehicleSetTotalWeight[]');
            })
        }
        if (tractorWeight !== undefined && tractorWeight !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>tractorWeight, 'tractorWeight');
        }
        if (tractorWeight2) {
            tractorWeight2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'tractorWeight[]');
            })
        }
        if (environmentalImpact !== undefined && environmentalImpact !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>environmentalImpact, 'environmentalImpact');
        }
        if (environmentalImpact2) {
            environmentalImpact2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'environmentalImpact[]');
            })
        }
        if (axlesCount !== undefined && axlesCount !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>axlesCount, 'axlesCount');
        }
        if (axlesCount2) {
            axlesCount2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'axlesCount[]');
            })
        }
        if (seatsCount !== undefined && seatsCount !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>seatsCount, 'seatsCount');
        }
        if (seatsCount2) {
            seatsCount2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'seatsCount[]');
            })
        }
        if (productionYear !== undefined && productionYear !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>productionYear, 'productionYear');
        }
        if (productionYear2) {
            productionYear2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'productionYear[]');
            })
        }
        if (acquisitionDate !== undefined && acquisitionDate !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>acquisitionDate, 'acquisitionDate');
        }
        if (acquisitionDate2 !== undefined && acquisitionDate2 !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>acquisitionDate2, 'acquisitionDate[]');
        }
        if (firstRegistrationDate !== undefined && firstRegistrationDate !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>firstRegistrationDate, 'firstRegistrationDate');
        }
        if (firstRegistrationDate2 !== undefined && firstRegistrationDate2 !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>firstRegistrationDate2, 'firstRegistrationDate[]');
        }
        if (taxEvent !== undefined && taxEvent !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>taxEvent, 'taxEvent');
        }
        if (taxEvent2) {
            taxEvent2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'taxEvent[]');
            })
        }
        if (vehicleSaleDate !== undefined && vehicleSaleDate !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>vehicleSaleDate, 'vehicleSaleDate');
        }
        if (vehicleSaleDate2 !== undefined && vehicleSaleDate2 !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>vehicleSaleDate2, 'vehicleSaleDate[]');
        }
        if (vehicleDeregistrationDate !== undefined && vehicleDeregistrationDate !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>vehicleDeregistrationDate, 'vehicleDeregistrationDate');
        }
        if (vehicleDeregistrationDate2 !== undefined && vehicleDeregistrationDate2 !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>vehicleDeregistrationDate2, 'vehicleDeregistrationDate[]');
        }
        if (createdAt !== undefined && createdAt !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>createdAt, 'createdAt');
        }
        if (createdAt2 !== undefined && createdAt2 !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>createdAt2, 'createdAt[]');
        }
        if (updatedAt !== undefined && updatedAt !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>updatedAt, 'updatedAt');
        }
        if (updatedAt2 !== undefined && updatedAt2 !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>updatedAt2, 'updatedAt[]');
        }
        if (deletedAt !== undefined && deletedAt !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>deletedAt, 'deletedAt');
        }
        if (deletedAt2 !== undefined && deletedAt2 !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>deletedAt2, 'deletedAt[]');
        }
        if (page !== undefined && page !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>page, 'page');
        }
        if (itemsPerPage !== undefined && itemsPerPage !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>itemsPerPage, 'itemsPerPage');
        }
        if (pagination !== undefined && pagination !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>pagination, 'pagination');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (apiKey) required
        localVarCredential = this.configuration.lookupCredential('apiKey');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json',
                'application/ld+json',
                'text/html',
                'application/octet-stream'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/tax_objects`;
        return this.httpClient.request<Array<TaxObjectAppEntityTaxObjectRead>>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Retrieves a TaxObject resource.
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getTaxObjectItemTaxObjectItem(requestParameters?: GetTaxObjectItemTaxObjectItemRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<TaxObjectAppEntityTaxObjectItemRead>;
    public getTaxObjectItemTaxObjectItem(requestParameters?: GetTaxObjectItemTaxObjectItemRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<HttpResponse<TaxObjectAppEntityTaxObjectItemRead>>;
    public getTaxObjectItemTaxObjectItem(requestParameters?: GetTaxObjectItemTaxObjectItemRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<HttpEvent<TaxObjectAppEntityTaxObjectItemRead>>;
    public getTaxObjectItemTaxObjectItem(requestParameters?: GetTaxObjectItemTaxObjectItemRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<any> {
        const id = requestParameters?.id;
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getTaxObjectItemTaxObjectItem.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (apiKey) required
        localVarCredential = this.configuration.lookupCredential('apiKey');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json',
                'application/ld+json',
                'text/html',
                'application/octet-stream'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/tax_objects/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        return this.httpClient.request<TaxObjectAppEntityTaxObjectItemRead>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Updates the TaxObject resource.
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public patchTaxObjectTaxObjectItem(requestParameters?: PatchTaxObjectTaxObjectItemRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<TaxObjectAppEntityTaxObjectRead>;
    public patchTaxObjectTaxObjectItem(requestParameters?: PatchTaxObjectTaxObjectItemRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<HttpResponse<TaxObjectAppEntityTaxObjectRead>>;
    public patchTaxObjectTaxObjectItem(requestParameters?: PatchTaxObjectTaxObjectItemRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<HttpEvent<TaxObjectAppEntityTaxObjectRead>>;
    public patchTaxObjectTaxObjectItem(requestParameters?: PatchTaxObjectTaxObjectItemRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<any> {
        const id = requestParameters?.id;
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling patchTaxObjectTaxObjectItem.');
        }
        const taxObject = requestParameters?.taxObject;

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (apiKey) required
        localVarCredential = this.configuration.lookupCredential('apiKey');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json',
                'application/ld+json',
                'text/html',
                'application/octet-stream'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/merge-patch+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/tax_objects/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        return this.httpClient.request<TaxObjectAppEntityTaxObjectRead>('patch', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: taxObject,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Creates a TaxObject resource.
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public postTaxObjectTaxObjectCollection(requestParameters?: PostTaxObjectTaxObjectCollectionRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<TaxObjectAppEntityTaxObjectRead>;
    public postTaxObjectTaxObjectCollection(requestParameters?: PostTaxObjectTaxObjectCollectionRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<HttpResponse<TaxObjectAppEntityTaxObjectRead>>;
    public postTaxObjectTaxObjectCollection(requestParameters?: PostTaxObjectTaxObjectCollectionRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<HttpEvent<TaxObjectAppEntityTaxObjectRead>>;
    public postTaxObjectTaxObjectCollection(requestParameters?: PostTaxObjectTaxObjectCollectionRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<any> {
        const taxObject = requestParameters?.taxObject;

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (apiKey) required
        localVarCredential = this.configuration.lookupCredential('apiKey');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json',
                'application/ld+json',
                'text/html',
                'application/octet-stream'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/ld+json',
            'text/html',
            'application/octet-stream'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/tax_objects`;
        return this.httpClient.request<TaxObjectAppEntityTaxObjectRead>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: taxObject,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
